import { DiToken, registerDiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// biome-ignore lint/style/useNamingConvention: must be that way
export const LOG_ROCKET_API_KEY: DiToken<string> = new DiToken<string>('logRocketApiKey', {
  factory: () => ''
});

export function registerLogRocketApiKey(apiKey: string): void {
  registerDiToken(LOG_ROCKET_API_KEY, () => apiKey);
}
